import React, { useState } from "react";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";

/**
 * Renders listing component for interestDiscovery module.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - The module information.
 * @param {Function} props.handleViewClick - The function to handle view click use for viewing the details  of a record.
 * @param {Function} props.handleDeleteClick - The function to handle delete click use for delete the details of a record.
 * @param {Function} props.handleEditClick - The function to handle edit click use for editing the details of a record.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const interestDiscovery  = useAppSelector((state : RootState) => state.interestDiscovery);
  const [statusData, setStatusData] = useState<any>();
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={interestDiscovery.rowData}
        onGridReadyWithDispatch={setGrid}
        paginationPageSize={interestDiscovery.perPage}
        cacheBlockSize={interestDiscovery.perPage}
        columnDefs={columnDefs}
        context={{ setStatusData }}
      />
    </>
  );
};

export default Listing;
